import React, { Fragment } from 'react';

import withAuthServerSideProps from '@/libs/auth';
import { PageLayout } from '@/layouts/shared';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTag from '@/components/ui/MetaTag';
const ShippingAndDeliveryPolicyPage = () => {
  const companyName = process.env.COMPANY_NAME;
  return (
    <Fragment>
      <MetaTag title="CHÍNH SÁCH VẬN CHUYỂN - GIAO NHẬN" description="CHÍNH SÁCH VẬN CHUYỂN - GIAO NHẬN" />
      <div className="container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10">
        <div className="tw-flex tw-gap-y-1 tw-flex-col tw-leading-7">
          <h1 className="tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase">
            CHÍNH SÁCH VẬN CHUYỂN - GIAO NHẬN
          </h1>
          <div className="tw-leading-7 tw-flex tw-flex-col tw-gap-y-2">
            <h3 className="tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold">1. Giao hàng trong nước:</h3>
            <p className="tw-font-semibold">* Tại Tp.HCM:</p>
            <ul>
              <li>
                - Phương thức giao hàng: giao trực tiếp bởi nhân viên An Thư sau khi đơn hàng được xử lý và thông báo
                cho Khách Hàng trước khi giao.
              </li>
              <li>
                - Hình thức thanh toán: thanh toán ngay khi nhận hàng bằng tiền mặt hoặc chuyển khoản (chỉ giao hàng khi
                đã nhận cọc trước đó tối thiểu 10%).
              </li>
              <li>
                - Trường hợp phát sinh chậm trễ hoặc chuyển đổi hình thức giao hàng: nhân viên An Thư sẽ thông báo trước
                với Khách Hàng.
              </li>
              <li>- Phí giao hàng: miễn phí.</li>
            </ul>
            <p className="tw-font-semibold"> * Các Tỉnh thành khác:</p>
            <ul>
              <li>- Phương thức giao hàng: thông qua đơn vị vận chuyển uy tín.</li>
              <li>
                - Hình thức thanh toán: thanh toán đủ 100% giá trị đơn hàng trước khi An Thư chuyển giao đơn hàng cho
                đơn vị vận chuyển.{' '}
              </li>
              <li>
                - Trường hợp phát sinh chậm trễ hoặc chuyển đổi hình thức giao hàng: nhân viên An Thư sẽ thông báo trước
                với Khách Hàng.{' '}
              </li>
              <li>- Phí giao hàng: miễn phí .</li>
            </ul>
          </div>
          <div className="tw-leading-7 tw-flex tw-flex-col tw-gap-y-2">
            <h3 className="tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold">2. Vận chuyển quốc tế: </h3>
            <ul>
              <li>- Phương thức giao hàng: thông qua đơn vị vận chuyển uy tín.</li>
              <li>
                - Hình thức thanh toán: thanh toán đủ 100% giá trị đơn hàng trước khi An Thư chuyển giao đơn hàng cho
                đơn vị vận chuyển.
              </li>
              <li>
                - Trường hợp phát sinh chậm trễ hoặc chuyển đổi hình thức giao hàng: nhân viên An Thư sẽ thông báo trước
                với Khách Hàng.
              </li>
              <li>- Phí giao hàng: theo biểu phí của đơn vị vận chuyển cho từng quốc gia.</li>
            </ul>
          </div>
          <div className="tw-leading-7 tw-flex tw-flex-col tw-gap-y-2">
            <h3 className="tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold">2. Cam kết: </h3>
            <ul>
              <li>
                - Đơn hàng của Khách Hàng thông qua đơn vị vận chuyển đều có bảo hiểm đền bù vì vậy chỉ giao hàng đúng
                chính chủ.
              </li>
              <li>
                - Đơn hàng của Khách Hàng do nhân viên An Thư vận chuyển sẽ giao hàng đúng chính chủ hoặc người được
                Khách Hàng ủy quyền, chỉ định.
              </li>
              <li>
                - An Thư chịu trách nhiệm đảm bảo cho Khách Hàng nhận hàng đúng quy cách như khi mua trực tiếp tại cửa
                hàng.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale }: GetServerSidePropsContext) => {
    return {
      props: {
        layout: PageLayout.New,
        ...(await serverSideTranslations(locale as string, ['layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default ShippingAndDeliveryPolicyPage;
